import { unwrapColumnsFromGroups } from './unwrap-columns';
export const getHiddenColumns = (columns) => {
    if (!columns.length) {
        return [];
    }
    const isGroupsProvided = columns.some((column) => column.hasOwnProperty('columns'));
    if (!isGroupsProvided) {
        return columns.filter((i) => i.hidden).map((column) => column.id);
    }
    else {
        const columnsForFilter = unwrapColumnsFromGroups(columns);
        return columnsForFilter.filter((i) => i.hidden).map((column) => column.id);
    }
};
export const getInvisibleColumns = (columns) => columns.filter((i) => !i.isVisible && !i.isVirtualColumn).map((column) => column.id);
